import React from "react";

import { OverflowTooltip } from "components";
import { Application, TableCellProp } from "types";

const merchantNameColumn = () => ({
	Header: "Merchant Name",
	accessor: "applicationDBAName",
	disableSortBy: true,
	Cell: ({ row: { original } }: TableCellProp<Application>) => {
		return (
			<OverflowTooltip onlyOnLaptop title={original?.merchant_name}>
				{original?.merchant_name}
			</OverflowTooltip>
		);
	},
});

export default merchantNameColumn;
